import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments';
import { HttpClient } from '@angular/common/http';
import { ResinSource } from '../enums';
import { ResinInfo } from '../models';
import { Observable } from 'rxjs';
import { trimEnd } from 'lodash-es';

const basePath = trimEnd(`${environment.apiBaseUrl}`, '/');

@Injectable({ providedIn: 'root' })
export class ResinApiClient {
  private readonly _http = inject(HttpClient);

  listAllResins(source: ResinSource = ResinSource.ds): Observable<ResinInfo> {
    switch (source) {
      case ResinSource.rwc:
        return this._http.get<ResinInfo>(`${basePath}/rwc-resin`);
      default:
        return this._http.get<ResinInfo>(`${basePath}/ds-resin`);
    }
  }
}
